<template>
  <div class="mc-cmp">
    <div class="mc-cmp__head">
      <h3 class="mc-cmp__title">
        Bot vs. Humano
      </h3>
      <p class="mc-cmp__sub">
        Comparações rápidas no período selecionado
      </p>
    </div>

    <div
      v-if="resumo"
      class="mc-cmp__exec"
    >
      {{ resumo }}
    </div>

    <div
      v-for="bloco in blocos"
      :key="bloco.key"
      class="mc-cmp__bloco"
    >
      <div class="mc-cmp__bloco-head">
        <h4 class="mc-cmp__bloco-title">
          {{ bloco.titulo }}
        </h4>
        <p class="mc-cmp__bloco-sub">
          {{ bloco.subtitulo }}
        </p>
      </div>

      <div class="mc-cmp__valores">
        <p class="mc-cmp__linha mc-cmp__linha--bot">
          🤖 {{ bloco.botLinha }}
        </p>
        <p class="mc-cmp__linha mc-cmp__linha--hum">
          👩‍💻 {{ bloco.humanoLinha }}
        </p>
      </div>

      <!-- Tempo: barras proporcionais (maior = mais minutos) -->
      <template v-if="bloco.modoBarra === 'dupla-tempo'">
        <p class="mc-cmp__hint">
          Quanto menor a barra, menos tempo de atendimento.
        </p>
        <div class="mc-cmp__bar-block mc-cmp__bar-block--twocol">
          <span class="mc-cmp__bar-lbl">Bot</span>
          <div class="mc-cmp__track">
            <div
              class="mc-cmp__fill mc-cmp__fill--bot"
              :style="{ width: `${bloco.barBotPct}%` }"
            />
          </div>
        </div>
        <div class="mc-cmp__bar-block mc-cmp__bar-block--twocol">
          <span class="mc-cmp__bar-lbl">Humano</span>
          <div class="mc-cmp__track">
            <div
              class="mc-cmp__fill mc-cmp__fill--hum"
              :style="{ width: `${bloco.barHumanoPct}%` }"
            />
          </div>
        </div>
      </template>

      <!-- Taxa: duas barras de % -->
      <template v-else-if="bloco.modoBarra === 'dupla-pct'">
        <p class="mc-cmp__hint">
          Percentual de conversas encerradas com sucesso.
        </p>
        <div class="mc-cmp__bar-block">
          <span class="mc-cmp__bar-lbl">Bot</span>
          <div class="mc-cmp__track">
            <div
              class="mc-cmp__fill mc-cmp__fill--bot"
              :style="{ width: `${bloco.barBotPct}%` }"
            />
          </div>
          <span class="mc-cmp__bar-pct">{{ bloco.barBotPct }}%</span>
        </div>
        <div class="mc-cmp__bar-block">
          <span class="mc-cmp__bar-lbl">Humano</span>
          <div class="mc-cmp__track">
            <div
              class="mc-cmp__fill mc-cmp__fill--hum-alt"
              :style="{ width: `${bloco.barHumanoPct}%` }"
            />
          </div>
          <span class="mc-cmp__bar-pct">{{ bloco.barHumanoPct }}%</span>
        </div>
      </template>

      <!-- Participação: barra única segmentada -->
      <template v-else-if="bloco.modoBarra === 'segmento'">
        <p class="mc-cmp__hint">
          Distribuição das conversas com bot no período.
        </p>
        <div class="mc-cmp__seg-wrap">
          <div class="mc-cmp__seg-track">
            <div
              class="mc-cmp__seg-bot"
              :style="{ flex: `0 0 ${Math.min(100, bloco.barBotPct)}%` }"
            />
            <div
              class="mc-cmp__seg-hum"
              :style="{ flex: `0 0 ${Math.min(100, bloco.barHumanoPct)}%` }"
            />
          </div>
        </div>
        <div class="mc-cmp__seg-legend">
          <span><i class="mc-dot mc-dot--bot" /> Bot {{ bloco.barBotPct }}%</span>
          <span><i class="mc-dot mc-dot--hum" /> Humanos {{ bloco.barHumanoPct }}%</span>
        </div>
      </template>

      <p class="mc-cmp__destaque">
        {{ bloco.destaque }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComparativoBotHumano',
  props: {
    resumo: {
      type: String,
      default: '',
    },
    blocos: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.mc-cmp {
  background: var(--mc-surface);
  border-radius: var(--mc-radius-lg);
  border: 1px solid var(--mc-border);
  box-shadow: var(--mc-shadow-md);
  padding: 1.35rem 1.35rem 1.5rem;
  margin-bottom: 1.75rem;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.mc-cmp:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(93, 42, 140, 0.1);
}

.mc-cmp__head {
  margin-bottom: 1rem;
}

.mc-cmp__title {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--mc-text);
  margin: 0 0 0.2rem;
}

.mc-cmp__sub {
  margin: 0;
  font-size: 0.82rem;
  color: var(--mc-text-muted);
  font-weight: 500;
  line-height: 1.4;
}

.mc-cmp__exec {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.45;
  color: var(--mc-text);
  padding: 0.85rem 1rem;
  margin-bottom: 1.25rem;
  border-radius: var(--mc-radius-md);
  background: linear-gradient(135deg, rgba(157, 78, 221, 0.1) 0%, rgba(228, 106, 169, 0.08) 100%);
  border: 1px solid var(--mc-border);
}

.mc-cmp__bloco {
  padding-bottom: 1.15rem;
  margin-bottom: 1.15rem;
  border-bottom: 1px solid var(--mc-border);
}

.mc-cmp__bloco:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.mc-cmp__bloco-title {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--mc-text-soft);
  margin: 0 0 0.35rem;
}

.mc-cmp__bloco-sub {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--mc-text-muted);
  margin: 0 0 0.65rem;
  line-height: 1.4;
}

.mc-cmp__valores {
  margin-bottom: 0.5rem;
}

.mc-cmp__linha {
  font-size: 0.88rem;
  font-weight: 700;
  margin: 0 0 0.2rem;
  color: var(--mc-text);
}

.mc-cmp__hint {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--mc-purple);
  margin: 0 0 0.5rem;
}

.mc-cmp__bar-block {
  display: grid;
  grid-template-columns: 52px 1fr 40px;
  align-items: center;
  gap: 0.45rem;
  margin-bottom: 0.35rem;
}

.mc-cmp__bar-block--twocol {
  grid-template-columns: 52px 1fr;
}

.mc-cmp__bar-block:last-of-type {
  margin-bottom: 0.5rem;
}

.mc-cmp__bar-lbl {
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--mc-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.mc-cmp__track {
  height: 12px;
  border-radius: var(--mc-radius-pill);
  background: var(--mc-surface-tint);
  overflow: hidden;
  box-shadow: inset 0 1px 3px rgba(75, 42, 123, 0.06);
}

.mc-cmp__fill {
  height: 100%;
  border-radius: var(--mc-radius-pill);
  min-width: 4px;
  transition: width 0.5s ease;
}

.mc-cmp__fill--bot {
  background: linear-gradient(90deg, #6f35d0 0%, #b43fcf 100%);
}

.mc-cmp__fill--hum {
  background: linear-gradient(90deg, #ff8a7a 0%, #f6c768 100%);
}

.mc-cmp__fill--hum-alt {
  background: linear-gradient(90deg, #7aa7ff 0%, #59c9a5 100%);
}

.mc-cmp__bar-pct {
  font-size: 0.78rem;
  font-weight: 800;
  color: var(--mc-text);
  text-align: right;
}

.mc-cmp__seg-wrap {
  margin-bottom: 0.45rem;
}

.mc-cmp__seg-track {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 14px;
  border-radius: var(--mc-radius-pill);
  overflow: hidden;
  background: var(--mc-border);
}

.mc-cmp__seg-bot {
  background: linear-gradient(90deg, #7b3fe4 0%, #e46aa9 100%);
  transition: width 0.5s ease;
}

.mc-cmp__seg-hum {
  background: linear-gradient(90deg, #d4c8e8 0%, #e8e0f2 100%);
  transition: width 0.5s ease;
}

.mc-cmp__seg-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--mc-text-soft);
}

.mc-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 0.3rem;
  vertical-align: middle;
}

.mc-dot--bot {
  background: #7b3fe4;
}

.mc-dot--hum {
  background: #c4b5dc;
}

.mc-cmp__destaque {
  font-size: 0.84rem;
  font-weight: 700;
  color: var(--mc-purple);
  margin: 0.65rem 0 0;
  line-height: 1.4;
}
</style>
